
import { createSelector } from 'reselect'

const innerStateSelector = state => state.homepage

const storiesSelector = createSelector(
   innerStateSelector,
   (state) => (state.stories)
);

const videosSelector = createSelector(
   innerStateSelector,
   (state) => (state.videos)
);
const photosetsSelector = createSelector(
   innerStateSelector,
   (state) => (state.photosets)
);
const storeSelector = createSelector(
   innerStateSelector,
   (state) => (state.store)
);

const fetchingSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetching)
);
const siteHeaderSelector = createSelector(
   innerStateSelector,
   (state) => (state.siteHeader)
);
const aboutMeSelector = createSelector(
   innerStateSelector,
   (state) => (state.aboutMe)
);
const recordedStreamsSelector = createSelector(
   innerStateSelector,
   (state) => (state.recordedStreams)
);
export {
   storiesSelector,
   videosSelector,
   fetchingSelector,
   photosetsSelector,
   siteHeaderSelector,
   storeSelector,

   aboutMeSelector,
   recordedStreamsSelector,
}
